import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import G288FreespinRecord from "integration/freespin-record";

export default class G288FreespinsRetriggered extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord() as G288FreespinRecord;

        let triggered = false;

        if (record && record.retriggerFreespins) {
            triggered = true;
        }

        return triggered ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/decisions/freespins-retriggered.ts